import * as Yup from 'common/yup';
import {KeyPairType, KeyPairTypeSchema} from 'types/diplomat/enums/KeyPairType';
import {SymmetricAlgorithm, SymmetricAlgorithmSchema} from 'types/SymmetricAlgorithm';
import {HashAlgorithm, HashAlgorithmSchema} from 'types/HashAlgorithm';
import {passphrase} from 'common/yup/customs/passphrase';
import {addOpenPGPSubKeySchema} from 'types/diplomat/keys/AddOpenPGPSubKey';
import {enums} from 'types/enums';

export const CreateOpenPGPKeyPairNames = {
   curveType: 'curveType',
} as const;

export const createOpenPGPKeyPairSchema = Yup.object({
   keyName: Yup.string().required(),
   keyType: KeyPairTypeSchema.default(KeyPairType.enum.ECDH),
   bitStrength: Yup.number().default(2048),
   [CreateOpenPGPKeyPairNames.curveType]: Yup.string()
      .oneOf(enums.eccurveType.keys)
      .default(enums.eccurveType.enum.NISTP521),
   userID: Yup.idString().required(),
   passPhrase: passphrase().required(),
   overwrite: Yup.boolean().default(false),
   existingPassphrase: Yup.string().oneOf(
      [Yup.ref('passPhrase'), null],
      'Passphrase entries do not match'
   ),
   lifetime: Yup.number().default(0),
   symmetricAlgorithms: Yup.array()
      .of(SymmetricAlgorithmSchema)
      .default([SymmetricAlgorithm.enum.AES_256]),
   hashAlgorithms: Yup.array()
      .of(HashAlgorithmSchema)
      .default([HashAlgorithm.enum.SHA512, HashAlgorithm.enum.SHA256]),
   folderId: Yup.idString(),
   subkeys: Yup.array().of(addOpenPGPSubKeySchema),
});

export type ICreateOpenPGPKeyPair = Yup.InferType<typeof createOpenPGPKeyPairSchema>;
